export default __webpack_public_path__ + "static/vepa_v2-6ceab73b44c956140c9a04900fdc8327.png";